import styled from 'styled-components'

export const OverlayContainer = styled.div<{ open?: boolean }>`
  width: 100vw;
  height: 100svh;
  min-height: 100svh;

  background-color: var(--foreground---neutral, rgba(20, 23, 31, 0.6));

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ open }) => (open ? 1 : 0)};

  transition: opacity 150ms ease-out;

  position: absolute;
  top: 0;
  left: 0;

  /* Avoid Chrome to see Safari hack */
  @supports (-webkit-touch-callout: none) {
    /* The hack for Safari */
    height: -webkit-fill-available;
    min-height: -webkit-fill-available;
  }
`

export const Container = styled.div<{ open?: boolean; heightOverlay?: number; heightChildren?: number }>`
  width: 100vw;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: top 150ms ease-out;

  position: absolute;
  top: ${({ open, heightOverlay, heightChildren }) =>
    open ? `calc(${heightOverlay}px - ${heightChildren || 0}px)` : `${heightOverlay}px`};
  left: 0;
`
